import logo from './logo.svg';
import './App.css';
import React from 'react';
import { format } from "date-fns";

class AppAll extends React.Component {


  state = {
    terminy: {}
  }

  constructor(props) {
    super(props);
    this.nacitajTerm();
    this.interval = setInterval(this.toggleImage, 3000);
  }


  benef1 = "";
  benef2 = "";
  benef3 = "";
  benef4 = "";
  kodKurzu = "";
  urlKurzu = "";
  volneMesta = "";
  vBratislave = "";
  urlObrazku = "";
  urlObrazku1 = "";
  datumDenKurzu  = "";
  terminy = {};
  mesiacKurzu  = "";
  currentIndex = 0;
  images = [];


  naplnTextyPodlaJazyka() {

    let nacitanePremium = document.getElementById("lit-cs-lang4r").innerHTML;
     this.ikonaBenefitu = <i className='fas fa-solid fa-star lit-cmp-benefit'></i>;
      if (this.props.dalsi == "NA1") {
        this.urlObrazku = "/../style/loga_kurzov/na1/na1-ads.jpg";
        // this.urlObrazku = "/img/na1-ads.jpg";
        if (String(nacitanePremium) == 'sk') {
          this.vBratislave = "v Bratislave";
          this.tlacitko = "rezervovať miesto";
          this.kodKurzu = "Naučte sa konfigurovať routre Cisco";
          this.urlKurzu = "/kurz/ccna/na1-smerovanie-tcpip-sietach-prakticka-konfiguracia-routra-cisco.html";
          this.benef1 = "praktická konfigurácia";
          this.benef2 = "vlastný súkromný lab";
          this.benef3 = "výnimočne hodnotený kurz";
          this.benef4 = "príručka v cene";
          this.volneMesta = "ešte "+this.volne+" voľné miesta";
        } else if (String(nacitanePremium) == 'cz') {
          this.vBratislave = "";
          this.tlacitko = "rezervovat místo";
          this.kodKurzu = "Naučte se konfigurovat routery Cisco";
          this.urlKurzu = "/cz/kurz/ccna/na1-smerovani-v-tcpip-sitich-prakticka-konfigurace-routeru-cisco.html";
          this.benef1 = "praktická konfigurace";
          this.benef2 = "vlastní soukromý lab";
          this.benef3 = "výjimečně hodnocený kurz";
          this.benef4 = "příručka v ceně";
          this.volneMesta = "ještě "+this.volne+" volná místa";
        }
       } else if (this.props.dalsi == "NA0"){
        this.urlObrazku = "/../style/loga_kurzov/na0/na0-ads.jpg";
        // this.urlObrazku = "/img/na0-ads.jpg";
        if (String(nacitanePremium) == 'sk') {
          this.vBratislave = "v Bratislave";
          this.tlacitko = "rezervovať miesto";
          this.kodKurzu = "Štart do konfigurácie TCP/IP sietí v prostredí Cisco";
          this.urlKurzu = "/kurz/ccna/na0-administracia-lanwan-a-navrh-tcpip-sieti-zakladne-koncepty.html";
          this.benef1 = "bez prechádzajúcich znalostí";
          this.benef2 = "knižka v cene";
          this.benef3 = "vynikajúce hodnotenie";
          this.volneMesta = "ešte "+this.volne+" voľné miesta";
        } else if (String(nacitanePremium) == 'cz') {
          this.vBratislave = "";
          this.tlacitko = "rezervovat místo";
          this.kodKurzu = "Start do konfigurace TCP/IP sítí v prostředí Cisco";
          this.urlKurzu = "/cz/kurz/ccna/na0-administrace-lanwan-a-navrh-tcpip-siti-zakladni-koncepty.html";
          this.benef1 = "bez předchozích znalostí";
          this.benef2 = "knížka v ceně";
          this.benef3 = "vynikající hodnocení";
          this.volneMesta = "ještě "+this.volne+" volná místa";
        }
       }
  }
  
  

  vypisDatum(data){
    let vysledokWs = data.result;
      for(var i=0; i<vysledokWs?.length; i++ ){
        if (this.props.dalsi == vysledokWs?.[i].id) {
          this.volne = vysledokWs?.[i].termin.volne;
          var date = new Date(vysledokWs?.[i].termin.zaciatok);
          this.datumDenKurzu = format(date, "dd");
          this.mesiacKurzu = format(date, "MM");
          var mesiacSlovne = "";

          let jazyk = document.getElementById("lit-cs-lang4r").innerHTML;

          if (String(jazyk) == 'sk'){

            switch(this.mesiacKurzu) {
              case "01" : mesiacSlovne = "Januára"; break;
              case "02" : mesiacSlovne = "Februára"; break;
              case "03" : mesiacSlovne = "Marca"; break;
              case "04" : mesiacSlovne = "Apríla"; break;
              case "05" : mesiacSlovne = "Mája"; break;
              case "06" : mesiacSlovne = "Júna"; break;
              case "07" : mesiacSlovne = "Júla"; break;
              case "08" : mesiacSlovne = "Augusta"; break;
              case "09" : mesiacSlovne = "Septembra"; break;
              case "10" : mesiacSlovne = "Októbra"; break;
              case "11" : mesiacSlovne = "Novembra"; break;
              case "12" : mesiacSlovne = "Decembra"; break;
            }
          } else if(String(jazyk) == 'cz') {

            switch(this.mesiacKurzu) {
              case "01" : mesiacSlovne = "Ledna"; break;
              case "02" : mesiacSlovne = "Února"; break;
              case "03" : mesiacSlovne = "Března"; break;
              case "04" : mesiacSlovne = "Dubna"; break;
              case "05" : mesiacSlovne = "Května"; break;
              case "06" : mesiacSlovne = "Června"; break;
              case "07" : mesiacSlovne = "Července"; break;
              case "08" : mesiacSlovne = "Srpna"; break;
              case "09" : mesiacSlovne = "Září"; break;
              case "10" : mesiacSlovne = "Října"; break;
              case "11" : mesiacSlovne = "Listopadu"; break;
              case "12" : mesiacSlovne = "Prosince"; break;
            }
          }
          this.datumDenKurzu = this.datumDenKurzu+". "+mesiacSlovne;

        }
      }
  }
  benefitHvezdicka(){
    if(this.benef4 == "") {
      this.ikonaBenefitu = null;
    }
  }
  nacitajTerm = () => {
    fetch('https://www.ciscoskolenia.eu/engine/ws/termin/?idks='+this.props.dalsi)
   .then(response => response.json())
   .then((data) => {
    this.setState( {terminy: data});
    this.vypisDatum(data)
    this.naplnTextyPodlaJazyka();
 })
}

  render() {
    return (
      <a href={this.urlKurzu}>
      <div className="lit-cmp-blog-ads-dop row rounded shadow m-3">
            <div className='row'>
              <div className='col-lg-4'>
              <a href={this.urlKurzu}>
              <img className='img-fulid lit-cmp-img m-2' src={this.urlObrazku} id={'id-ads-'+this.props.dalsi}/>
                {/* <img className='img-fulid rounded-circle lit-cmp-ba-maly-obrazok m-2' src='/../style/loga_kurzov/na0/na0.png'/> */}
              </a>
              </div>
                <div className='col-lg-8'>
                <a href={this.urlKurzu}>
                      <p className='lit-cmp-ba-wrap-text-ads fs-4'>{this.kodKurzu}</p>
                    </a>
                  <div className='row'>
                  <div className='col-lg-8'>
                    <div id='lit-cmp-ul-ads'>
                      <p>{this.terminy.status}</p>
                    <ul id='benefit'>
                      <li>{this.ikonaBenefitu}{this.benef1}</li>
                      <li>{this.ikonaBenefitu}{this.benef2}</li>
                      <li>{this.ikonaBenefitu}{this.benef3}</li>
                      {this.benefitHvezdicka()}
                      <li>{this.ikonaBenefitu}{this.benef4}</li>       
                    </ul>
                    </div>
                    <p className='lit-cmp-datum text-start'><i className="fa-solid fa-circle-exclamation p-2"></i>{this.volneMesta}</p>
                  </div>
                  <div className='col-lg-4 lit-cmp-cta-wrap'>
                    <p className='lit-cmp-datum'>{this.datumDenKurzu}<br></br>{this.vBratislave}</p>
                    <button className='btn lit-cmp-cta-button mb-3'>{this.tlacitko}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </a>
    );

    }
}

export default AppAll;
